define([], function() {
	let AdobeEvents = {

		// fields definition
		eventName: '', 
		productItems: [],
		contextVars: '',
		adobeAnalyticsData: {},
		event: {
			name:{
				VIEWPDP: 'commerce.productViews',
				ADDTOCART: 'commerce.productListAdds',
				VIEWCART: 'commerce.productListViews',
				ORDER: 'commerce.purchases',
				EMAILSIGNUP: 'Email SignUp'
			},
		},
		language: {
			FRENCH: '-25'
		},

		/**
		 * Initialization of the module.
		 */
		init: function (eventName, productItems, adobeAnalyticsData, contextVars) {
			AdobeEvents.eventName = eventName;
			AdobeEvents.productItems = productItems;
			AdobeEvents.adobeAnalyticsData = adobeAnalyticsData;
			AdobeEvents.contextVars = contextVars;
			$(document).ready(function () {
				let adobeURL = AdobeEvents.adobeAnalyticsData.serviceURL;
				if(typeof adobeURL !== 'undefined' && adobeURL.trim().length !== 0){
					let adobeObject = AdobeEvents.getAdobeAnalyticsEventObject();
					COSTCO.util.sha256(AdobeEvents.getAdobeUUID(), hash => {
						 if (hash) {
							 adobeObject.body.xdmEntity._id = hash;
						 }
						 AdobeEvents.sendAdobeEvent(adobeURL, JSON.stringify(adobeObject));
					});
				}
			});
		}, 
		
		/**
		 * Init call only if user is logged in
		 */
		initEventIfLoggedIn: function (eventName, productItems, adobeAnalyticsData, contextVars) {
			if (COSTCO.util.isUserLoggedIn()) {
				AdobeEvents.init(eventName, productItems, adobeAnalyticsData, contextVars);
			}
		},

		sendAdobeEvent: function (url, payload, noConsentRequired = false) {
			if(typeof url === 'undefined' || url.trim().length === 0){
				//skip if url is not set
				return;
			}
			const saleOfInfoCode = "C0004";
			let personalizedAdvConsent = costcoConsentManager.checkConsent(saleOfInfoCode);
			//send adobe events only when the personalized advertising is active on cookie settings or if no consent required when the consent is implicit
			if(personalizedAdvConsent || noConsentRequired){
				COSTCO.util.ajax({
					url: window.location.protocol + '//' + window.location.host + '/' +'CostcoAdobeAuthCmd?storeId='+ AdobeEvents.contextVars.storeId +'&catalogId=' + AdobeEvents.contextVars.catalogId,
					method: 'GET',
					done: function done(data, textStatus, jqXHR, options) {
						data = JSON.parse(data);
						if (data.accessToken != null || data.status != '') {
							return AdobeEvents.sendEvent(url, payload, data.accessToken);
						} else {
							console.log('Error bearer token is missing or empty');
						}
					}, fail: function fail(data) {
						console.log('Unexpected Error Occured while retrieving bearer token');
					}
				});
			}
		},

		sendEvent: function (url, payload, bearerToken) {
			if(typeof url === 'undefined' || url.trim().length === 0){
				//skip if url is not set
				return;
			}
			let adobeFlowId = $("input[name='adobeFlowId']").val();
			let adobeSandBoxName = $("input[name='adobeParamSandBox']").val()
			COSTCO.util.ajax({
				url: url,
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + bearerToken,
					'x-adobe-flow-id': adobeFlowId,
					'x-sandbox-name': adobeSandBoxName
				},
				data: payload,
				done: function done(data, textStatus, jqXHR, options) {
					if (data.status != null || data.status != '') {
						if (AdobeEvents.contextVars.eventName === 'Connections Email SignUp') {
							window.location.replace(window.location.protocol + '//' + window.location.host + '/' + 'costco-connection-confirmation.html');
						}
						if (typeof AdobeEvents.event.name.EMAILSIGNUP != 'undefined' && AdobeEvents.event.name.EMAILSIGNUP != '') {
							if (AdobeEvents.event.name.EMAILSIGNUP == AdobeEvents.contextVars.eventName) {
								if (COSTCO.util.isUSStore()) {
									window.location.replace(window.location.protocol + '//' + window.location.host + '/' + 'email-sign-up-confirmation.html');
								}
								if (COSTCO.util.isCAStore()) {
									window.location.replace(window.location.protocol + '//' + window.location.host + '/' + 'email-sign-up-confirmation.html?email='+ $("input[name='email']").val());
								}
							}
						}
					} else {
						console.log('Error sending Adobe event');
					}
				}, fail: function fail(data) {
					console.log('Unexpected Error Occured while sending Adobe event');
				}
			});
		},
		
		sendEmailSubscriptionEvent: function (emailPopUpUrl, contextVars, data) {
			AdobeEvents.contextVars = contextVars;
			emailPopUpUrl = emailPopUpUrl.replace('http://', 'https://');
			let emailPopUpPayload = AdobeEvents.returnEmailSubscriptionAdobeAnalyticsObject(data);
			if (COSTCO.util.isCABDStore() || COSTCO.util.isUSBDStore()) {
				delete emailPopUpPayload.consents.marketing.email.subscriptions;
			} else {
				if (COSTCO.util.isUSStore()) {
					emailPopUpPayload.consents.marketing.email.subscriptions.Costco_US_Daily = {};
					emailPopUpPayload.consents.marketing.email.subscriptions.Costco_US_Daily.val = AdobeEvents.getDaily(data);
				} else {
					emailPopUpPayload.consents.marketing.email.subscriptions.Costco_CA_Daily = {};
					emailPopUpPayload.consents.marketing.email.subscriptions.Costco_CA_Daily.val = AdobeEvents.getDaily(data);
				}
			}
			AdobeEvents.sendAdobeEvent(emailPopUpUrl, JSON.stringify(emailPopUpPayload),true);
		},

		getAdobeAnalyticsEventObject: function () {
			let adobeAnalyticsEventObject = {
				header: AdobeEvents.getEventHeader(),
				body: AdobeEvents.getEventBody()
			}
			return adobeAnalyticsEventObject;
		},
		
		returnEmailSubscriptionAdobeAnalyticsObject: function (data) {
			return {
				memberNumber: data.memberNumber,
				webMembershipType: data.webMembershipType,
				source: COSTCO.util.getSource(),
				listSource: data.listSource,
				sourceRegion: COSTCO.util.getLocale().slice(-2),
				emailAddress: data.emailAddress,
				activeInd: "A",
				languagePref: AdobeEvents.getLanguagePreference(data.listSource),
				homeLocationNum: "",
				homeLocationRegionCode: "",
				warehouse: data.warehouse,
				zip: AdobeEvents.getZipCode(data),
				consents: {
					marketing: {
						email: {
							reason: "subscribe",
							Time: new Date().toISOString(),
							subscriptions: {
								Costco_Digital_Connections: {
									val: AdobeEvents.getConnections(data)
								}
							},
							val: "y"
						}
					}
				}
			}
		},

		getEventHeader: function () {
			return {
				schemaRef : {
					id: AdobeEvents.adobeAnalyticsData.schemaRefId,
					contentType: AdobeEvents.adobeAnalyticsData.schemaRefContenType
				},
				imsOrgId: AdobeEvents.adobeAnalyticsData.imsOrgId,
				datasetId: AdobeEvents.adobeAnalyticsData.datasetId,
				flowId: AdobeEvents.adobeAnalyticsData.flowId,
				source: {
					name: AdobeEvents.adobeAnalyticsData.sourceName
				}
			}
		},

		getEventBody: function () {
			return {
				xdmMeta: AdobeEvents.getXdmMeta(),
				xdmEntity: AdobeEvents.getXdmEntity()
			}
		},  
		
		getLanguagePreference: function(source) {
			if ((source === 'EmailPopUp' || source === 'Email SignUp') && !(COSTCO.util.isUSStore() || COSTCO.util.isUSBDStore())
					&& document.getElementsByName('slid_1').length === 2) {
				let isFirstOptionChecked = document.getElementsByName('slid_1')[0].checked;
				if (!isFirstOptionChecked) {
					return COSTCO.util.getLocale() == 'en-CA' ? 'FR' : 'EN';
				}
			}
			return COSTCO.util.getLocale().slice(0,2).toUpperCase();
		},

		getXdmMeta: function () {
			return {
				schemaRef : {
					id: AdobeEvents.adobeAnalyticsData.schemaRefId,
					contentType: AdobeEvents.adobeAnalyticsData.schemaRefContenType
				}
			}
		},

		getXdmEntity: function () {
			return {
				_costco: {
					costcoIdentity: {
						hashedCostcoID: $.cookie("costcoHashId"),
						sourceRegion: AdobeEvents.adobeAnalyticsData.sourceRegion
					}
				},
				commerce: AdobeEvents.getCommerce(),
				eventType: AdobeEvents.eventName,
				extSourceSystemAudit: {
					lastActivityDate: new Date().toISOString(),
					lastUpdatedBy: AdobeEvents.adobeAnalyticsData.lastUpdatedBy
				},
				identityMap: AdobeEvents.getCostcoHashedId(),
				productListItems: AdobeEvents.getProductItemsDetails(),
				timestamp: new Date().toISOString(),
				web: {
					webInteraction: {
						region: (AdobeEvents.contextVars.language == AdobeEvents.language.FRENCH) ? 'FR' : 'EN',
					},
					webPageDetails: {
						URL: document.getElementsByTagName("title")[0].baseURI.split('?')[0],
						name: document.getElementsByTagName("title")[0].innerText.replace(/\r?\n|\r/g,"")
					}
				}
			}
		},
		
		getCostcoHashedId: function () {
			return {
				costcoHashedID: [
					{
						authenticatedState: 'authenticated',
						id: $.cookie("costcoHashId"),
						primary: true
					}
				]
			}
		},
		
		/**
		 * Adobe require UUID to mark particular event with the suffix of the event.
		 */
		getAdobeUUID: function() {
			let dt = new Date().getTime();
			let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				let r = (dt + Math.random()*16)%16 | 0;
				dt = Math.floor(dt/16);
				return (c=='x' ? r :(r&0x3|0x8)).toString(16);
			});
			let id = uuid + '-' + COSTCO.util.getCookieByName('costcoHashId');
			return id;
		},
		
		getCommerce: function () {
			if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWPDP) {
				return {
					cart: {
						cartSource: AdobeEvents.getCartSource()
					},
					productViews: {
						value: AdobeEvents.productItems[0].priceTotal
					}
				}
			} else if (AdobeEvents.eventName == AdobeEvents.event.name.ADDTOCART) {
				return {
					cart: {
						cartID: AdobeEvents.contextVars.orderId,
						cartSource: AdobeEvents.getCartSource()
					},
					productListAdds: {
						value: AdobeEvents.productItems[0].priceTotal
					}
				}
			} else if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWCART) {
				if (typeof AdobeEvents.contextVars.orderId != 'undefined' && AdobeEvents.contextVars.orderId != '') {
					localStorage.setItem("adobeOrderId", AdobeEvents.contextVars.orderId);
				}
				return {
					cart: {
						cartID: AdobeEvents.getCartOrderId(),
						cartSource: AdobeEvents.getCartSource()
					},
					productListViews: {
						value: AdobeEvents.contextVars.priceTotal
					}
				}
			} else if (AdobeEvents.eventName == AdobeEvents.event.name.ORDER) {
				localStorage.removeItem("adobeOrderId", AdobeEvents.contextVars.orderId);
				return {
					order: {
						currencyCode: AdobeEvents.contextVars.currencyCode,
						discountAmount: AdobeEvents.contextVars.discountAmount,
						priceTotal: AdobeEvents.contextVars.priceTotal,
						purchaseOrderNumber: AdobeEvents.contextVars.purchaseOrderNumber
					},
					cart: {
						cartID: AdobeEvents.contextVars.orderId,
						cartSource: AdobeEvents.getCartSource()
					},
					purchases: {
						value: AdobeEvents.contextVars.priceTotal
					}
				}
			}
		},
		
		getCartOrderId: function () {
			if (localStorage.getItem("adobeOrderId") === null) {
				return;
			} else {
				return localStorage.getItem("adobeOrderId");
			}
		},
		
		getProductItemsDetails: function () {
			if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWCART) {
				return AdobeEvents.getCartItemsDetails();
			} else if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWPDP) {
				if($("#product-page").attr('data-bi-private')) {
					AdobeEvents.productItems[0].productImageUrl = window.location.hostname;
					AdobeEvents.productItems[0].product = window.location.hostname;
				} 
				AdobeEvents.productItems[0].quantity = ($('#add-to-cart-btn').length > 0 && $('#add-to-cart-btn').hasClass('out-of-stock') != true) ? 1 : -1;
			} 
			return AdobeEvents.productItems;
		},
		
		
		getCartItemsDetails: function () {
			if (typeof AdobeEvents.productItems != 'undefined' && AdobeEvents.productItems.length > 0) {
				for (let i = 0; i < AdobeEvents.productItems.length; i++) {
					let orderItemNumberInArray = i+1;
					if($("#order-item_" + orderItemNumberInArray).attr('data-bi-private')) {
						AdobeEvents.productItems[i].productImageUrl = window.location.hostname;
						AdobeEvents.productItems[i].product = window.location.hostname;
					} else {
						AdobeEvents.productItems[i].productImageUrl = $('#order-item_' + orderItemNumberInArray + ' .item-thumbnail img').attr('src');
						AdobeEvents.productItems[i].product = $('#order-item_' + orderItemNumberInArray + ' .product-title a').attr('href');
					}
					if (AdobeEvents.contextVars && AdobeEvents.contextVars.outOfStock && AdobeEvents.contextVars.outOfStock.length > 0) {
						AdobeEvents.productItems[i].quantity = AdobeEvents.getOutOfStockQuantity(AdobeEvents.productItems[i].SKU, AdobeEvents.productItems[i].quantity);
					}
				}
			}
			return AdobeEvents.productItems;
		},
		
		getOutOfStockQuantity: function(partnumber, quantity) {
			for (let i = 0; i < AdobeEvents.contextVars.outOfStock.length; i++) {
				if (AdobeEvents.contextVars.outOfStock[i] == partnumber) {
					return (quantity != -1) ? -1 * quantity  : quantity;
				}
			}
			return quantity;
		},
		
		getCartSource: function () {
			if(COSTCO.util.isBusinessDelivery()){
				return AdobeEvents.adobeAnalyticsData.sourceRegion + 'BD'
			} else {
				return AdobeEvents.adobeAnalyticsData.sourceRegion + 'BC'
			}
		},
		
		getZipCode: function (data) {
			if (COSTCO.util.isUSStore() || COSTCO.util.isUSBDStore()) {
				return data.zip;
			} else if (COSTCO.util.isCAStore() || COSTCO.util.isCABDStore()) {
				return data.postalCode;
			}
		},
		
		getConnections: function (data) {
			if (data.listSource === 'Connections_EmailSignUp') {
				return 'y';
			} else {
				return 'n';
			}
		},
		
		getDaily: function(data) {
			if(data.listSource === 'Connections_EmailSignUp') {
				return 'n';
			} else {
				return 'y';
			}
		}
	};
	if (typeof window.COSTCO === 'undefined') {
		window.COSTCO = {};
	}
	window.COSTCO.AdobeEvents = AdobeEvents;
	return AdobeEvents;
});


// WEBPACK FOOTER //
// ./js/adobe/adobe-analytics-events.js